import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InfoDialogComponent, InfoDialogData } from '../components/shared/info-dialog/info-dialog.component';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InfoDialogService {

  constructor(private dialog: MatDialog) { }

  /**
   * Opens an information dialog with the specified title and message
   * @param title The dialog title
   * @param message The dialog message
   * @param icon Optional icon to display (default: 'info')
   * @param iconColor Optional icon color (default: 'primary')
   * @param buttonText Optional custom text for the button (default: 'OK')
   * @param buttonIcon Optional custom icon for the button (default: 'check')
   * @returns Observable<void>
   */
  openInfoDialog(
    title: string,
    message: string,
    icon: string = 'info',
    iconColor: 'primary' | 'accent' | 'warn' | 'error' | 'success' = 'primary',
    buttonText: string = 'OK',
    buttonIcon: string = 'check'
  ): Observable<void> {
    const dialogRef: MatDialogRef<InfoDialogComponent> = this.dialog.open(
      InfoDialogComponent,
      {
        width: '400px',
        disableClose: false,
        data: {
          title,
          message,
          icon,
          iconColor,
          buttonText,
          buttonIcon
        }
      }
    );

    return dialogRef.afterClosed();
  }

  /**
   * Opens an error dialog with predefined error styling
   */
  openErrorDialog(message: string, title: string = 'Error'): Observable<void> {
    return this.openInfoDialog(
      title,
      message,
      'error',
      'error',
      'OK',
      'close'
    );
  }

  /**
   * Opens a success dialog with predefined success styling
   */
  openSuccessDialog(message: string, title: string = 'Success'): Observable<void> {
    return this.openInfoDialog(
      title,
      message,
      'check_circle',
      'success',
      'OK',
      'check'
    );
  }

  /**
   * Opens a warning dialog with predefined warning styling
   */
  openWarningDialog(message: string, title: string = 'Warning'): Observable<void> {
    return this.openInfoDialog(
      title,
      message,
      'warning',
      'warn',
      'OK',
      'check'
    );
  }
}
